import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import UnsubscribeTemplate from "../../templates/UnsubscribeTemplate/UnsubscribeTemplate";
import { unsubscribe, validateUnsubscribe } from "../../services/Unsubscribeservice";

const UnsubscribeScreen = () => {
  const [searchParams] = useSearchParams();
  // Email pré-rempli depuis le lien du mail : /unsubscribe?email=xxx@yyy.com
  const [email, setEmail] = useState(searchParams.get("email") || "");
  const [reason, setReason] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("idle"); // idle | success | error
  const [apiError, setApiError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validation = validateUnsubscribe({ email, reason });
    setErrors(validation);
    if (Object.keys(validation).length > 0) return;

    setLoading(true);
    setApiError("");
    const result = await unsubscribe({ email, reason });
    setLoading(false);

    if (result.ok) setStatus("success");
    else {
      setStatus("error");
      setApiError(result.message);
    }
  };

  return (
    <>
      <Helmet>
        <title>Se désabonner des alertes</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <UnsubscribeTemplate
        email={email}
        reason={reason}
        errors={errors}
        loading={loading}
        status={status}
        apiError={apiError}
        onEmailChange={(v) => {
          setEmail(v);
          setErrors((p) => ({ ...p, email: undefined }));
        }}
        onReasonChange={(v) => {
          setReason(v);
          setErrors((p) => ({ ...p, reason: undefined }));
        }}
        onSubmit={handleSubmit}
      />
    </>
  );
};

export default UnsubscribeScreen;